'use strict';

customerZone

    .controller('MyProductsController', ['$log', '$q', '$window', '$scope',  '$location', 'config', 'Session',
        'BalanceService', 'ProductService', 'SubscriptionService', 'utils', 'errorCode', function(
            $log, $q, $window, $scope, $location, config, session, BalanceService, ProductService, SubscriptionService,
            utils, errorCode){
            var self = this;
            self.loading = false;
            self.credit = undefined;
            self.subscriptionOptions = [];

            self.pickedProducts = [];
            self.subscriber = function(){
                return session.subscriber();
            };

            self.subscribers = function(){
                return session.subscribers();
            };

            self.isPostpaidOnTransatel = session.flags('postpaid_on_transatel');

            var init = function(){
                self.credit = self.subscriber().isPrepaid() ? BalanceService.balance.credit : undefined;

                $scope.$on('balanceRefreshed', function(event, balance){
                    self.credit = (self.subscriber() && self.subscriber().isPrepaid()) ? balance.credit : undefined;
                });

                BalanceService.refresh();
                self.loading = utils.translate('loading_data');

                $q.all([loadProducts(), loadOnboardingOptions()]).then(function(){
                    self.loading = false;
                });
            };

            self.payOptionsUsingCredit = function(){
                return self.subscriber() && self.subscriber().isPrepaid();
            };

            self.goToProduct = function(){
                if (self.selectedNewProductId)
                    $location.path('/registration/sales').search('product', self.selectedNewProductId);
            };

            self.confirmOrder = function(password){
                var productId = self.pickedProducts[0].id;
                var orderPromise =
                    SubscriptionService.buyBundle(session.subscription().id, productId, null, null, password)
                        .then(function(){
                            reset();
                            self.credit = undefined;
                            BalanceService.refresh();
                        }).catch(function(error){
                            if (errorCode.is(error, errorCode.INVALID_CREDENTIALS)){
                                busy.passThrough('incorrect_password');
                            }
                            if (errorCode.is(error, errorCode.PACKAGE_ALREADY_ACTIVE)) {
                                busy.showError('you_cannot_buy_this_package_because_you_already_have_it');
                            }
                            throw error;
                        });
                var busy = utils.showBusy(orderPromise, 'processing_order', 'order_processing');
                return busy.wrappedPromise;
            };

            var reset = function(){
                self.pickedProducts = [];
            };

            /**
             * Load the categories of products from the backend.
             * The products will automatically be grouped by type.
             * @return a promise that resolves when the categories have loaded
             */
            var loadProducts = function(){
                return ProductService.getSubscriptionOptions(session.subscriber())
                    .then(function(options){
                        self.subscriptionOptions = options;
                    }, function(error){
                        $log.error('Failed to load products: ', error);
                        utils.showError();
                    });
            };

            var loadOnboardingOptions = function(){
                return ProductService.getSubscriptionProducts(undefined, session.profile())
                    .then(function(options){
                        self.onboardingOptions = options
                            .filter(function(product) { return product.isPrepaid(); })
                            .map(function (product) {
                                return {
                                    url: '#!/registration/sales?product=' + product.id,
                                    product: product
                                };
                            });
                    })
                    .catch(function(error){
                        $log.error('Failed to load onboarding options', error);
                    });
            };

            init();

        }]);
